import { httpV2 } from "@/api/index";

const Qs = require("qs");

/**
 * @sumary Chama a API para buscar as informações da configuração de diagnósticos.
 * @param {number} monitoringElementId - Id da turbina.
 * @returns {promise} Promise da chamada da API.
 */
const GetDiagnosticSettings = function(monitoringElementId = 0)
{
	return httpV2.get(`/WindTurbinesDiagnosticSettings/${monitoringElementId}`);
};

export default { GetDiagnosticSettings };
